import { TFileTypes } from '../../types/messageFiles';

export const getMessageFileSendType = (imageMimeTypes: string[], type: string): TFileTypes => {
  if (imageMimeTypes.includes(type)) {
    return 'imageAsDocument';
  }

  return 'document';
};
